// The translator. Pure — tests call it directly.
//
// Resolution order: active locale → the EN source catalogue → the key itself.
// A visible key in the UI is a louder defect signal than silent empty text, and
// the catalogue-parity test (tests/i18n.test.js) is what stops it reaching a
// student.
//
// Interpolation is `{{name}}` and nothing else. A NUMBER value is routed through
// the active locale's number formatter, so «۳ مورد» in Persian and «3 items» in
// English come from the same call and no screen has to remember to localise a
// count. Pass a STRING to opt out — a year, a gift code, a formulary slug.
//
// Markup interpolation is deliberately impossible: a catalogue that can inject
// elements is a catalogue that can inject an unreviewed layout.

const TOKEN = /\{\{(\w+)\}\}/g;

export function interpolate(template, vars, formatNumber) {
  if (!vars) return template;
  return String(template).replace(TOKEN, (match, name) => {
    if (!(name in vars)) return match;
    const value = vars[name];
    if (typeof value === 'number') return formatNumber ? formatNumber(value) : String(value);
    return value == null ? '' : String(value);
  });
}

/**
 * @param catalogs   { [locale]: { [key]: string } }
 * @param fallback   the source catalogue object (EN)
 * @param locale     active locale id
 * @param formatNumber used for numeric interpolation values
 */
export function createTranslator({ catalogs, fallback, locale, formatNumber }) {
  const active = catalogs[locale] || {};

  const t = (key, vars) => {
    const template = active[key] ?? fallback[key] ?? key;
    return interpolate(template, vars, formatNumber);
  };

  /** For copy that is genuinely optional — render the element only if it exists. */
  t.has = (key) => key in active || key in fallback;

  return t;
}
